const doc = [({"en":({"js":({"admin":({"reimbursement_attachments":({"expandable_content":({"attachment":"Attachment"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;